/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useEffect, useState} from "react";
import {Form, Radio, Select, Spin} from "antd";
import {getApiHost} from "../../../utils";
import Axios from "axios";


const WidgetImpCheck = ({ parkType, setParkType, defaultParkDict, setCurrentPark }) => {
  const [latestParkDict, setLatestParkDict] = useState({
    국립공원: null,
    도립공원: null,
    군립공원: null,
  });
  const [parkListDict, setParkListDict] = useState({
    국립공원: [],
    도립공원: [],
    군립공원: [],
  });

  // 국립공원/도립공원/군립공원 카테고리 선택이 변경될 때마다, 공원 목록을 갱신합니다.
  useEffect(() => {
    async function refresh() {
      if ( parkListDict[parkType].length === 0 ) {
        const url = getApiHost() + '/gis/nationalpark_list.json';
        try {
          const { data } = await Axios.get(url, {params: {parkKind: parkType}});
          const parkList = data.map(({RX, RY, LX, LY, PKNM}) => ({
            rx: RX,
            ry: RY,
            lx: LX,
            ly: LY,
            name: PKNM,
          }));
          setParkListDict(prev => ({
            ...prev,
            [parkType]: parkList,
          }));

          onChangePark(defaultParkDict[parkType]);
        }
        catch(e) {
          console.error(e);
        }
      }
    }
    refresh();
  }, [parkType]);

  useEffect(() => {
    const selectedParkName = latestParkDict[parkType];
    const mountain = parkListDict[parkType].find(({name}) => selectedParkName === name);
    setCurrentPark(mountain);
  }, [latestParkDict, parkType, parkListDict, defaultParkDict]);

  const onChangePark = useCallback((selectedParkName) => {
    setLatestParkDict(prev => ({
      ...prev,
      [parkType]: selectedParkName,
    }));
  }, [parkType, parkListDict]);

  return (
    <Form.Item>


      {Object.entries(parkListDict).map(([categoryName, parkList]) =>
        <div key={categoryName} hidden={categoryName !== parkType}>
          <Select placeholder={`${categoryName}을 선택해주세요.`}
                  onChange={onChangePark}
                  value={latestParkDict[parkType]}
                  loading={parkList.length === 0}
                  notFoundContent={<Spin size="small" />}
                  style={{ width: '100%' }, {display:'none'}}>
            {parkList.map(({ name }) => {
              return <Select.Option value={name} key={name}>{name}</Select.Option>;
            })}
          </Select>
        </div>
      )}
    </Form.Item>
  );
};

const BUTTON_STYLE = {
  flex: 1,
  textAlign: 'center',
};


export default WidgetImpCheck;
